<template>
  <div>
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="true"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <!-- <sidebar-item :key="homeRoute.code" :item="homeRoute" /> -->
        <sidebar-item v-for="route in routeList" :key="route.code" :item="route" />
        <sidebar-item
          v-if="userInfo.id && userInfo.loginName.indexOf('system') > -1"
          :key="functionRoute.code"
          :item="functionRoute"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import SidebarItem from './SidebarItem';
import variables from '@/styles/variables.scss';

export default {
  components: { SidebarItem },
  data() {
    return {
      homeRoute: {
        tag: 'home',
        code: 'home',
        text: '工作台',
        icon: 'menu_home'
      },
      functionRoute: {
        tag: 'functionModule',
        code: 'functionModule',
        text: '功能模块',
        icon: 'menu_system'
      },
      routeList: []
    };
  },
  computed: {
    ...mapState({
      navTree: state => state.menu.navTree
    }),
    ...mapGetters(['sidebar', 'userInfo']),
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // 高亮
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    }
  },
  created() {
    this.routeList = this.navTree;
  }
};
</script>
